/* eslint-disable import/prefer-default-export */
export const fieldTypes = {
  str: 'str',
  bool: 'bool',
  float: 'float',
};
